var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpMobileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 0C5.36761 0 0 5.367 0 12C0 18.6323 5.367 24 12 24C18.6324 24 24 18.633 24 12C24 5.36761 18.633 0 12 0ZM11.6449 17.6165C10.9657 17.6165 10.4445 17.0479 10.4445 16.4002C10.4445 15.7368 10.9815 15.184 11.6449 15.184C12.3084 15.184 12.8611 15.7368 12.8611 16.4002C12.8611 17.0478 12.3241 17.6165 11.6449 17.6165ZM13.4456 11.472C12.5768 12.1512 12.561 12.6251 12.561 13.4464C12.561 13.7466 12.403 14.0941 11.6291 14.0941C10.9814 14.0941 10.7603 13.8571 10.7603 13.0358C10.7603 11.6774 11.3606 11.0297 11.8186 10.6349C12.3399 10.1925 13.2245 9.70294 13.2245 8.85C13.2245 8.12334 12.5926 7.77586 11.8028 7.77586C10.1917 7.77586 10.5392 8.99217 9.6862 8.99217C9.25974 8.99217 8.73848 8.70778 8.73848 8.0918C8.73848 7.23886 9.7178 5.97516 11.8502 5.97516C13.872 5.97516 15.2147 7.09669 15.2147 8.58145C15.2147 10.0662 13.872 11.1403 13.4456 11.472Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpMobileIcon);
export default __webpack_public_path__ + "static/media/help-mobile-icon.baf142f696b284a4d16af7daf83d23b3.svg";
export { ForwardRef as ReactComponent };